var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentCard = function SvgPaymentCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "6 11.5 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.222 11.5H7.778C6.796 11.5 6 12.284 6 13.25v17.5c0 .966.796 1.75 1.778 1.75h28.444c.982 0 1.778-.784 1.778-1.75v-17.5c0-.966-.796-1.75-1.778-1.75Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.96 26.97h-.046v-.271h.069l.088.19.076-.19h.067v.268h-.047v-.202l-.073.174h-.054l-.08-.174V26.969Zm-.2-.002h-.04v-.223h-.093V26.7h.234v.046h-.1v.223Z",
    fill: "#F69E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.52 16.383h-6.807v11.425h6.807V16.383Z",
    fill: "#F26122"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.445 22.095a7.274 7.274 0 0 1 .684-3.15 7.385 7.385 0 0 1 1.983-2.563 6.934 6.934 0 0 0-4.946-1.531 6.898 6.898 0 0 0-4.623 2.313 7.435 7.435 0 0 0-1.877 4.93c0 1.814.667 3.565 1.877 4.932a6.9 6.9 0 0 0 4.623 2.313 6.934 6.934 0 0 0 4.946-1.532 7.386 7.386 0 0 1-1.983-2.562 7.273 7.273 0 0 1-.684-3.15Z",
    fill: "#EA1D25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.552 22.095a7.215 7.215 0 0 1-1.056 3.818 7.371 7.371 0 0 1-2.925 2.714 6.927 6.927 0 0 1-7.459-.818 7.45 7.45 0 0 0 2.65-4.868 7.398 7.398 0 0 0-1.463-5.332 7.035 7.035 0 0 0-1.187-1.226 6.926 6.926 0 0 1 7.459-.819 7.37 7.37 0 0 1 2.924 2.714 7.215 7.215 0 0 1 1.057 3.817Z",
    fill: "#F69E1E"
  })));
};
export default SvgPaymentCard;